import { render } from "./LocalFilter.vue?vue&type=template&id=e0451f3e"
import script from "./LocalFilter.vue?vue&type=script&lang=js"
export * from "./LocalFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__